var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('HatsuiTableDisplay',{attrs:{"messages":this.messages}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }